// Libraries
import { Button, Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Fragment, ReactElement, useState } from 'react';
// Types
import { AdaptableDialogProps } from '../../AdaptableDialog.types';

/**
 * A custom modal component that can be used to display content in a modal format.
 *
 * @component
 * @param {AdaptableDialogProps} props - The props for the CustomModal component.
 * @returns {ReactElement} The CustomModal component.
 */
export const CustomModal = ({ children, buttonContent }: AdaptableDialogProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <Fragment>
      <Button onClick={handleOpen} variant='wrapper' p={2}>
        {buttonContent}
      </Button>
      <Modal isOpen={isOpen} onClose={handleClose} size='lg'>
        <ModalOverlay />
        <ModalContent>
          {children}
          <ModalCloseButton />
        </ModalContent>
      </Modal>
    </Fragment>
  );
};
